<template>
	<div class="stpf">
        <h3>公司员工食堂满意度调查问卷表</h3>
        <br/>
        <p>亲爱的同事：</p>
        <br/>
        <p style="text-indent: 24px;">您好！为了进一步了解您对员工食堂现状的感受及期望，希望您能抽出几分钟时间填写一下问卷，选出您认为符合实际情况的选项，并能针对员工食堂提出一些宝贵意见和建议，我们将会认真总结、分析并加以改进，努力提升食堂服务水平，感谢您的支持！</p>
        <br/>
        <header>
            <span>请选择公司</span><br/>
            <el-select v-model="org" placeholder="请选择"  clearable >
            <el-option
                v-for="item in options"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </header>
        <br/>

        <main>
            <span>1.  您对食堂的卫生状况满意吗？</span>
            <el-rate v-model="value1" :max=10></el-rate><br/>
            <span>2.  您认为食堂菜式品种更新情况如何？</span>
            <el-rate v-model="value2" :max=10></el-rate><br/>
            <span>3.  您认为食堂饭菜的份量如何？</span>
            <el-rate v-model="value3" :max=10></el-rate><br/>
            <span>4.  您认为食堂米饭的口感如何？</span>
            <el-rate v-model="value4" :max=10></el-rate><br/>
            <span>5.  您认为食堂菜品的味道如何？</span>
            <el-rate v-model="value5" :max=10></el-rate><br/>
            <span>6.  您认为食堂饭菜的新鲜度如何？</span>
            <el-rate v-model="value6" :max=10></el-rate><br/>
            <span>7.  您认为食堂就餐碗筷是否符合就餐标准？</span>
            <el-rate v-model="value7" :max=10></el-rate><br/>
            <span>8.  您认为食堂菜品荤素搭配如何？</span>
            <el-rate v-model="value8" :max=10></el-rate><br/>
            <span>9.  您认为食堂工作人员的态度如何？</span>
            <el-rate v-model="value9" :max=10></el-rate><br/>
            <span>10.  您在食堂就餐体验如何？</span>
            <el-rate v-model="value10" :max=10></el-rate><br/>

            <span>11.  您认为食堂有哪些方面需要改善,请提出建议：</span>
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="message">
            </el-input>
        </main>
     
        <br/>
        <br/>
        <footer style="padding: 0 20px;">
            <van-button type="info" size="small" @click="submit()" style="width: 100%;">提交</van-button>
        </footer>
        
    </div>
</template>

<script>
    import { url } from '../router/api';
    import shitang from "../config/option.js"

	export default{
        data() {
            return {
                options:shitang.shitang3,
                org:'',
                message:'',
                value1:null,
                value2:null,
                value3:null,
                value4:null,
                value5:null,
                value6:null,
                value7:null,
                value8:null,
                value9:null,
                value10:null,
            };
        },
        
        mounted() {
        },

        methods: {
            submit() {
             
                if(this.org=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择公司',
                    }).then(() => {});
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否提交',
                    }).then(() => {
                        this.axios.get(url + 'complaint/stpf', {
                            params:{
                                org:this.org,
                                message:this.message,
                                value1:this.value1,
                                value2:this.value2,
                                value3:this.value3,
                                value4:this.value4,
                                value5:this.value5,
                                value6:this.value6,
                                value7:this.value7,
                                value8:this.value8,
                                value9:this.value9,
                                value10:this.value10
                            }
                        }).then(res=> {
                            this.$dialog.alert({
                                title: '提示',
                                message: '提交成功',
                            }).then(() => {
                                this.org='',
                                this.message='',
                                this.value1=null,
                                this.value2=null,
                                this.value3=null,
                                this.value4=null,
                                this.value5=null,
                                this.value6=null,
                                this.value7=null,
                                this.value8=null,
                                this.value9=null,
                                this.value10=null
                            });
                        }).catch(err=> {});
                    }).catch(() => {});
                }
            },
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .stpf {
        padding-bottom: 40px;
        h3 {
            text-align: center;
        }
        p {
            margin: 0 20px;
        }
        main {
            padding:0 20px;
        }
        header {
            padding:0 20px;
        }
        span {
            display: inline-block;
            line-height: 30px;
        }
       
    }
</style>